import { module } from 'angular';

import { default as skypeServiceName, SkypeService } from './skype.service';

export default module('contact.agent.core.channel-digit.softphone.skype', [])
  // instanciate services module
  .run([skypeServiceName, () => {}])
  // service
  .service(skypeServiceName, SkypeService).name;
